import { createNode, ZonedDateTimeDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromZonedDateTime } from '../../utils/temporal';

export const ZonedDateTimeNode = createNode({
    id: 'ZonedDateTime',
    name: 'ZonedDateTime',
    description: 'Creates a ZonedDateTime value from date, time, and timezone components',
    aiDescription:
        'Takes number inputs on "Year", "Month", "Day", "Hour", "Minute", optionally "Second" and "Millisecond", and a "Timezone" string, and outputs a ZonedDateTime on the "ZonedDateTime" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Year: { kind: 'number' },
        Month: { kind: 'number' },
        Day: { kind: 'number' },
        Hour: { kind: 'number' },
        Minute: { kind: 'number' },
        Second: { kind: 'number' },
        Millisecond: { kind: 'number' },
        Timezone: { kind: 'string' },
    },
    optionalInPorts: ['Second', 'Millisecond'],
    outPorts: {
        ZonedDateTime: ZonedDateTimeDataType,
    },
    execute: function (input) {
        const dateTime = Temporal.PlainDateTime.from({
            year: input.inPorts.Year,
            month: Math.max(1, input.inPorts.Month),
            day: Math.max(1, input.inPorts.Day),
            hour: input.inPorts.Hour,
            minute: input.inPorts.Minute,
            second: input.inPorts.Second ?? 0,
            millisecond: input.inPorts.Millisecond ?? 0,
        });
        const zdt = dateTime.toZonedDateTime(input.inPorts.Timezone);
        return { output: { ZonedDateTime: fromZonedDateTime(zdt) } };
    },
});
